import { useQuery } from "@tanstack/react-query";
import { getInvoices } from "api/invoice.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetInvoices = () => {
  return useQuery({
    queryKey: QUERY_KEYS.invoices.list(),
    queryFn: gracefulList(getInvoices, { invoices: [] }),
    select: (data) =>
      data?.invoices || data?.data?.invoices || data?.data || [],
    staleTime: DEFAULT_STALE_TIME,
  });
};
